import React from "react";
import { HashRouter as Router, Route, Switch } from "react-router-dom";
import Login from "./pages/login";

export function Routes() {
  return (
    <Router>
      <Switch>
        <Route
          path={`/beneficiario`}
          exact
          component={Login}
        />
        <Route
          path={`/particular`}
          exact
          component={Login}
        />
        <Route
          path={`/suporte`}
          exact
          component={Login}
        />
        <Route
          path={`/medico`}
          exact
          component={Login}
        />
        <Route
          path={`/`}
          exact
          component={Login}
        />
      </Switch>
    </Router>
  );
}
